<template>
	<div class="product">
		<div class="proonlogy-top">
			<img src="../../static/img/wepro.jpg"/>
			<div class="bannerMask"><div></div></div>
			<div class="com-tit">
				<span>
					<img src="../../static/img/solveicon.png"/><b>我们的产品</b>
				</span>
				<p>多年产品研发经验，采用CMMI管理模式体系以上国际先进、成<br />
熟的开发工具和语言</p>
			</div>
		</div>
		<div class="case-nav">
			
		</div>
		<div class="pro-detail">
			<ul>
				<li v-for="navli in pro" class="casenav" v-bind:class="{caseacli : chalid == navli.id}" @click.prevent="seltab(navli.id)">{{navli.title}}</li>
			</ul>
			<!-- <div class="pro-top-top">
				<h4>{{pro[chalid].title}}</h4>
				<div class="pro-line">	
				</div>
			</div> -->
			<!-- 环境监测智能综合管理系统 -->
			<div class="proinfo" v-if="chalid == 0 ">
				<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					应用场景：1.	城镇环境监测、旅游景区环境监测、江河湖泊湿地环境监测、森林山地环境监测与预警系统；
					2.	大型社区、农场、物流园的环境监测；
					3.	仓库环境：如粮食、烟草、医药、化工、食品等，主要为温湿度、气体含量、水质、酸碱度等；
					4.	机房环境监测：电流、电压、开关状态、发电机、蓄电池、电源、烟感、漏水、配电、温湿度、烟感、门禁、UPS、空调、电源等；
					5.	城镇洪涝、干旱灾害的监测预警。
				</p> 
				<p class="com-content">
					简介：环境监测智能综合管理系统是一个综合利用计算机网络技术、数据库技术、通信技术、自动控制技术、新型传感技术等构成的计算机网络，
					提供的一种以计算机技术为基础、基于集中管理监控模式的自动化、智能化和高效率的技术手段，统一进行生态监测、污染物监测、环境监测、
					自然灾害监测并实现分析与预警的一套智能化的系统。
				</p> 
				<p class="com-content">
					系统功能：通过配置不同的环境传感器，可实现针对性很强的解决方案，如空气质量监测、水质监测、土壤监测、污染物监测、
					动力监测、声音监测、火灾监测、光照监测等。
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/hjjc01.png" style="width: 80%; max-width: 100%"/>
				</div>
				<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p1-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p1-2.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
            <!--企业招投标系统-->
            <div class="proinfo" v-if="chalid == 1 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：企事业单位
				</p> 
				<p class="com-content">
					简介：能够有效降低招投标成本，使采购过程更具规范性和透明性，达到采购管理“公开、公正、公平”的目的，为各行业持续提供“专业、全面、可靠、合规”的招标解决方案。
				</p> 
				<p class="com-content">
					系统功能：覆盖招投标业务全过程，包括：网上发布招标信息、网上报名、网上报价、网上上传投标文件、网上保证金管理、网上结果公示公告、投标人信息管理、专家基础信息管理、
					开评标签到考勤管理、三方监管平台、短信平台接口、加解密码公共平台、数据共享与交换接口、电子监管接口。
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/qyztb.jpg" style="width: 80%; max-width: 100%"/>
				</div>
            </div>
			<!--公共资源业务系统-->
            <div class="proinfo" v-if="chalid == 2 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：事业单位、大型企业
				</p> 
				<p class="com-content">	
					简介：公共资源业务系统是专门针对公共资源交易中心的业务进行开发的综合管理系统，
					系统由统一的管理平台与工程交易、土地与矿业权交易、政府采购、产权交易等主要业务子系统组成。
				</p> 
				<p class="com-content">
					系统功能：可实现工程交易、土地与矿业权交易、政府采购、产权交易等各专项的全流程业务，可实现全程网上招投标、
					全程网上交易、全程的在线监测、统一的信息管理，具有高效、安全、稳定的特点，全面达到公共资源业务的公开、公平、
					公正的要求。
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/ggzy01.png" style="width: 60%; max-width: 100%"/>
				</div>
				<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p3-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p3-2.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p3-3.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p3-4.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
			<!--智慧旅游综合业务系统-->
            <div class="proinfo" v-if="chalid == 3 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：景区、园林、旅游事业单位
				</p> 
				<p class="com-content">	
					简介：智慧旅游综合业务系统提供针对旅游行业的综合业务管理；包括门户、OA、资产管理、园林专项业务、旅游专项管理等模块。
				</p> 
				<p class="com-content">
					系统功能：实现了统一信息管理、OA办公自动化，具有针对旅游行业的全程数字功能，包括网上售票、在线（VR）景区、数字景区，
					通过大数据的应用实现了人流管控、环境监测等智能化管理。
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/zhly01.png" style="width: 60%; max-width: 100%"/>
				</div>
				<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p4-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p4-2.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p4-3.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
            <!--新零售业务系统-->
            <div class="proinfo" v-if="chalid == 4 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：零售、批发、商贸类行业
				</p> 
				<p class="com-content">	
					简介：系统以中小企业为服务对象，从实现中小企业内部信息管理出发，对接“淘宝”类的大平台，做到充分利用平台资源的同时发挥中小企业的自身灵活性，
					切实帮助中小企业面对“新零售”的诸多挑战
				</p> 
				<p class="com-content">
					系统功能：分行业的进销存管理；提供微信、网店营销；实现桌面、移动端的全覆盖；实现店内销售、网上配送多种服务方式。
				</p>
				<div class="pro-singleimg">
					<img src="../../static/img/xls01.png" style="width: 60%; max-width: 100%"/>
				</div>
				<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p5-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
            <!--律师行业综合业务系统-->
            <div class="proinfo" v-if="chalid == 5 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：律师行业
				</p> 
				<p class="com-content">	
					简介：系统针对律师行业开发，解决了律师行业的信息化管理需求，包括资料管理、案件跟踪、事物审批、对接法院公开平台，实现了协同工作，有效的提升了律师团队的效率
				</p> 
				<p class="com-content">
					系统功能：协同办公，资料汇总，事物审批，案件管理
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/lshy01.png" style="width: 60%; max-width: 100%"/>
				</div>
				<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p6-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p6-2.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p6-3.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
			<!--通用OA业务系统-->
			<div class="proinfo" v-if="chalid == 6 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：贸易制造、地产建筑、医疗教育、物流服务等企事业、政府部位。
				</p> 
				<p class="com-content">	
					简介：OA管理系统由人力资源管理模块、信息中心、流程审批、公文管理、文档管理、任务管理、会议管理等子系统组成。适合企事业内部的办公审批流程管理。
				</p> 
				<p class="com-content">
					系统功能：通过电子公文流转改变了企业传统纸质公文办公模式，采用电子起草、传阅、审批、会签、签发、归档等电子化流转方式，真正实现无纸化办公。
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/oa01.png" style="width: 60%; max-width: 100%"/>
				</div>
								<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p7-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
			<!--智能综合指挥平台-->
			<div class="proinfo" v-if="chalid == 7 ">
            	<h4 class="small-tit">{{pro[chalid].smalltit}}</h4>
				<p class="com-content">
					行业：安防、消防、环保等
				</p> 
				<p class="com-content">	
					简介：系统采用了网络、多媒体、物联网等多种技术，具有智能化、可视化、精确化的统一综合指挥功能，由（1）GIS地图监视（2）视频监控与安全警报（3）
					车辆通行监控与交通疏导指挥（4）人流量监控与预警管理（5）统一信息发布（6）智能防火警报（7）环境监测系统（8）GPS北斗定位系统（9）视频会议（10）
					数字广播系统等专业模块与（11）统一指令系统组成。通过对各子系统功能的有机结合实现统一指挥与调度工作，满足景区、小区、商业综合体、工业园区、学校、
					村镇等区域公共安全的综合指挥工作。
				</p> 
				<p class="com-content">
					系统功能：实现了视频监控、多媒体发布、安防警报、环境监测、移动定位等专项功能，可实现各种业务系统的数据对接，
					具有数据分析功能，具有安全、稳定、网络化的特点
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/znzh01.png" style="width: 60%; max-width: 100%"/>
				</div>
								<p class="com-content">
					软件著作权证书：
				</p> 
				<div class="pro-singleimg">
					<img src="../../static/img/p8-1.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p8-2.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p8-3.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p8-4.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p8-5.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
					<img src="../../static/img/p8-6.jpg" style="width: 18%; height: auto; display: inline-block; margin: 1%;"/>
				</div>
            </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'product',
		data () {
			return {
				pro : [
				{id : 0 , imgsrc : 'static/img/wepro.jpg' , title : '环境监测管理系统' , smalltit : '环境监测智能综合管理系统'},
				{id : 1 , imgsrc : 'static/img/wepro.jpg' , title : '企业招投标系统' , smalltit : '企业招投标系统'},
				{id : 2 , imgsrc : 'static/img/wepro.jpg' , title : '公共资源业务系统' , smalltit : '公共资源业务系统'},
				{id : 3 , imgsrc : 'static/img/wepro.jpg' , title : '智慧旅游综合业务系统' , smalltit : '智慧旅游综合业务系统'},
				{id : 4 , imgsrc : 'static/img/wepro.jpg' , title : '新零售业务系统' , smalltit : '新零售业务系统'},
				{id : 5 , imgsrc : 'static/img/wepro.jpg' , title : '律师行业综合业务系统' , smalltit : '律师行业综合业务系统'},
				{id : 6 , imgsrc : 'static/img/wepro.jpg' , title : '通用OA业务系统' , smalltit : '通用OA业务系统'},
				{id : 7 , imgsrc : 'static/img/wepro.jpg' , title : '智能能综合指挥平台' , smalltit : '智能综合指挥平台'},
				],
				
				chalid : 0,
				
				navli : [
				{id : 0 , litit : '服务事业单位 '},
				{id : 1 , litit : '房地产 '},
				{id : 2 , litit : '政府 '},
				{id : 3 , litit : '旅游 '},
				{id : 4 , litit : '传媒 '},
				{id : 5 , litit : '律师 '},
				{id : 6 , litit : '教育 '},
				{id : 7 , litit : '医疗 '},
				],
				scrollWatch: true,
				lijudge : 0,
				selid : 0
			}
		},
		mounted(){	
			this.getID()
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			seltab(index) {
				this.chalid = index
			}
		},
	}
</script>

<style>
	.product{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.pro-detail{
		width: 80%;
		margin: 27px auto;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.pro-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.proonlogy-top {
		margin-top: -3vw;
	}
	.proonlogy-top img{
		width: 100%;		
	}
		.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.pro-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
	

	.product ul{
		width: 100%;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
		border-bottom: none;
	}
	.pro-detail ul li.casenav{
		display: inline-block;
		width: 12%;
		padding: 10px;
		background: #FFFFFF;
		margin-right: 2px;
		color: #666;
		transition: .2s all;
		font-size: 16px;
		cursor: pointer; 
		user-select: none;
	}
	
	.pro-detail ul li.casenav:hover{
	    transform: scale(1.05);
	    background: #C5DAE6 !important;
	    color: #008EE2 !important;

	}
	
	.pro-detail ul li.caseacli{
		color: #fff;
    	background: #1d8ce0;
	}
	.pro-detail ul{
		width: 100%;
		margin: 0 auto;
		text-align: center;
		margin-top: -3vw;
	}

	.pro-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.proinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.proinfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.proinfo img{
		text-align: center;
		max-width: 650px;
	}
	.pro-singleimg{
		text-align: center;
		position: relative;
	}
	.pro-singleimg img{
		width: 65%;
	}
	.pro-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 50px auto 0;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
		margin-bottom: 30px;
	}
	.proinfo p b{
		color: red;
	}
	.proinfo p.ggzyp{
		display: inline-block;
		width: 49%;
		position: relative;
		clear: both;
		margin: 10px 0;
	}	
	.proinfo p.info{
		margin: 10px 0;
	}
	.proinfo p.smallp b{
		color: #333333;
		font-size: 16px;
	}
	.proinfo p.smallp{
		margin: 10px 0;
	}
	.proinfo li{
		list-style: none;
		position: relative;
	}
	.proinfo li p{
		margin: 10px 0;
	}
	.proinfo li h3{
		font-size: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/product.vue